module.exports = __webpack_public_path__ + "static/img/10.91e25ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/word/10.png
// module id = vSPe
// module chunks = 1